import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

import { observer } from "mobx-react";
import { useNavigate } from "react-router-dom";

/* ------------------ FLAT SERVICES ARRAY ------------------ */
const services = [
  { name: "CLOTHES", price: 160, unit: "₹/kg", description: "Premium Wash & Fold with Steam Press" },

  { name: "Shirt", price: 150, description: "Premium wash & steam press" },
  { name: "Blazer", price: 250, description: "Delicate dry clean for blazers" },
  { name: "Coat", price: 250, description: "Heavy fabric deep clean" },
  { name: "Jacket", price: 250, description: "Winter/casual jacket dry clean" },
  { name: "Leather Jacket", price: 700, description: "Premium leather cleaning" },
  { name: "Sweater", price: 200, description: "Soft wool wash" },

  { name: "Kurta / Kurti", price: 175, description: "Gentle dry clean" },
  { name: "Normal Saree Dry Clean", price: 250, description: "Daily wear saree cleaning" },
  { name: "Silk Saree Dry Clean", price: 350, description: "Soft silk cleaning" },
  { name: "Party Saree Dry Clean", price: 400, description: "Special care heavy saree" },
  { name: "Dupatta Dry Clean", price: 100, description: "Light cleaning" },

  { name: "Single Bedsheet", price: 180, description: "Deep wash + steam press" },
  { name: "Double Bedsheet", price: 220, description: "Crisp steam finish" },
  { name: "Pillow Cover", price: 175, description: "Wrinkle-free wash" },
  { name: "Blanket (Single)", price: 350, description: "Deep clean" },
  { name: "Blanket (Double)", price: 500, description: "Sanitized drying" },
  { name: "Towel (Bath)", price: 100, description: "Soft antibacterial wash" },
  { name: "School Bag", price: 350, description: "Deep cleaning" },
  { name: "Travel Bag / Duffel", price: 400, description: "Heavy duty clean" },
];

/* ------------------ GROUP A–Z ------------------ */
const grouped = services.reduce((acc, item) => {
  const letter = item.name[0].toUpperCase();
  if (!acc[letter]) acc[letter] = [];
  acc[letter].push(item);
  return acc;
}, {});

const alphabets = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

/* ------------------ COMPONENT ------------------ */

const Prices = observer(() => {
  const navigate = useNavigate();

  const [searchQuery, setSearchQuery] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);

  const handleBookNow = () => {
    const custId = localStorage.getItem("custId");
    navigate(custId ? "/booking-tabs" : "/login");
  };

  return (
    <div>
      <Navbar />
      

      <section className="py-10 px-4 md:px-24 bg-gray-50 min-h-screen">

        {/* FULL STICKY HEADER */}
        <div className="sticky top-[120px] z-30 bg-gray-50 pb-4">

          <h2 className="text-3xl font-bold text-center text-yellow-700 mb-4">
            Our Pricing
          </h2>

          {/* Search */}
          <div className="flex justify-center mb-4">
            <input
              type="text"
              placeholder="Search items..."
              className="w-full md:w-1/2 px-4 py-2 border rounded-lg shadow-sm"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          {/* A–Z */}
          <div className="flex justify-center flex-wrap gap-2 mb-2">
            {alphabets.map((letter) => (
              <a
                key={letter}
                href={`#section-${letter}`}
                className="px-3 py-1 border rounded-md bg-white hover:bg-yellow-100"
              >
                {letter}
              </a>
            ))}
          </div>
        </div>

        {/* A–Z SECTIONS */}
        {alphabets.map((letter) => {
          const items = grouped[letter];
          if (!items) return null;

          const filtered = items.filter((i) =>
            i.name.toLowerCase().includes(searchQuery.toLowerCase())
          );

          if (filtered.length === 0) return null;

          return (
            <div key={letter} id={`section-${letter}`} className="mb-10">

              <h3 className="text-2xl font-bold mb-4 text-yellow-700">{letter}</h3>

              {/* SUB TABS */}
              <div className="flex flex-wrap gap-2 mb-4">
                {filtered.map((item, index) => (
                  <button
                    key={index}
                    onClick={() => setSelectedItem(item)}
                    className={`px-4 py-2 rounded-md border ${
                      selectedItem?.name === item.name
                        ? "bg-black text-yellow-400 border-black"
                        : "bg-white hover:bg-gray-100"
                    }`}
                  >
                    {item.name}
                  </button>
                ))}
              </div>

              {/* Selected Panel */}
              {selectedItem && (
                <div className="bg-white shadow rounded-lg p-6">
                  <h4 className="text-xl font-bold mb-2">{selectedItem.name}</h4>
                  <p className="text-gray-600 mb-4">{selectedItem.description}</p>
                  <p className="text-green-700 font-bold text-2xl mb-3">
                    ₹{selectedItem.price}
                  </p>

                  <button
                    onClick={handleBookNow}
                    className="text-yellow-700 border border-yellow-700 px-6 py-2 rounded-lg hover:bg-black hover:text-yellow-400"
                  >
                    Book
                  </button>
                </div>
              )}

            </div>
          );
        })}

      </section>

      <Footer />
    </div>
  );
});

export default Prices;
